import { Component, ViewChild } from '@angular/core';
import { AFSSelectInputComponent } from "@afs-ng/inputs";
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AssignEmployeesComponent } from "../../assign-components/assign-employees/assign-employees.component";
import { SupportAppointmentRequestConfirmation } from 'src/app/_provider/support/support.types';

@Component({
    selector: 'appointment-assign-accept',
    templateUrl: './appointment-assign-accept.component.html',
    styleUrls: ['./appointment-assign-accept.component.scss', '../../assign.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, AssignEmployeesComponent, AFSSelectInputComponent]
})
export class AppointmentAssignAcceptComponent {

  @ViewChild("assignEmployees") assignEmployees!: AssignEmployeesComponent

  public durationOptions = [
    {value: 15, name: "15 Minuten"},
    {value: 30, name: "30 Minuten"},
    {value: 45, name: "45 Minuten"},
    {value: 60, name: "1 Stunde"},
    {value: 120, name: "2 Stunden"},
    {value: 180, name: "3 Stunden"},
    {value: 240, name: "4 Stunden"},
    {value: 300, name: "5 Stunden"},
    {value: 360, name: "6 Stunden"},
    {value: 420, name: "7 Stunden"},
    {value: 480, name: "8 Stunden"},
  ]
  public selectedEmployeeIds: number[] = []
  public form: FormGroup = this.formBuilder.group({
    accepted: [true],
    selectedDuration: [60],
    rejectMessage: [""],
    withNewAppointment: [false],
    newAppointmentDate: [null],
  })

  public get appointmentRequestOptions(): SupportAppointmentRequestConfirmation{
    return {
      ...this.form.value,
      employeeIds: this.selectedEmployeeIds
    }
  }

  public get disabled(): boolean{
    return this.selectedEmployeeIds.length === 0
  }

  constructor(
    private formBuilder: FormBuilder
  ){}


  public clear(){
    if(this.assignEmployees) this.assignEmployees.clear()
    this.form.reset({
      accepted: true,
      employeeIds: [],
      selectedDuration: 60,
      rejectMessage: "",
      withNewAppointment: false,
      newAppointmentDate: null
    })
  }

}
